















import Addresses from "@/components/Addresses.vue";
import FactoryReferences from "@/components/FactoryReferences.vue";
import Footer from "@/components/Footer.vue";
import GalleryModal from "@/components/GalleryModal.vue";
import Introduction from "@/components/Introduction.vue";
import MenuBar from "@/components/MenuBar.vue";
import OpeningHours from "@/components/OpeningHours.vue";
import Profile from "@/components/Profile.vue";
import StoreReferences from "@/components/StoreReferences.vue";
import Welcome from "@/components/Welcome.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({
    components: {
        StoreReferences,
        OpeningHours,
        Addresses,
        MenuBar,
        Welcome,
        Introduction,
        Profile,
        FactoryReferences,
        Footer,
        GalleryModal
    },
})
export default class App extends Vue {
    @Action("setScrollPosition")
    public setScrollPosition: any;

    @Action("fetchInitializedSiteData")
    public fetchInitializedSiteData: any;

    @Action("setCurrentMediaIndex")
    public setCurrentMediaIndex: any;

    @State("mediasToShow")
    public mediaCollection: any;

    @State("currentMediaIndex")
    public currentMediaIndex: number;

    @State("isGalleryOpen")
    public isGalleryOpen: boolean;

    public constructor() {
        super();
    }

    public mounted() {
        window.addEventListener("scroll", this.handleScroll);
        this.fetchInitializedSiteData();
    }

    public handleScroll()  {
        this.setScrollPosition(window.scrollY);
    }

    @Watch("isGalleryOpen")
    private toggleGalleryModal() {
        const body = document.querySelector("body");
        if (!body) {
            return;
        }
        if (this.isGalleryOpen) {
            body.classList.add("gallery-modal-open");
        } else {
            body.classList.remove("gallery-modal-open");
        }
    }
}
